<template>
  <div class="state-wrap-v2">
    <div class="row">
      <div class="main_timeline">
        <!-- Days Filter (left) -->
        <div class="day-filter-v2" v-click-outside="closeDaysList">
          <div class="title-filter-v2" @click="showDaysList = !showDaysList">
            <img
              class="title-down-v2"
              src="../../images/dashboard/down-blue.png"
              alt="#"
            />
            <span class="drop-down-menu-v2">{{ titleMap[dayStep] }}</span>
          </div>
          <ul class="day-list-v2" v-if="showDaysList">
            <li class="day-list-item-v2" @click="sortbydays(30)">30 Days</li>
            <li class="day-list-item-v2" @click="sortbydays(60)">60 Days</li>
            <li class="day-list-item-v2" @click="sortbydays(90)">90 Days</li>
            <li class="day-list-item-v2" @click="sortbydays(1)">Q1</li>
            <li class="day-list-item-v2" @click="sortbydays(2)">Q2</li>
            <li class="day-list-item-v2" @click="sortbydays(3)">Q3</li>
            <li class="day-list-item-v2" @click="sortbydays(4)">Q4</li>
            <li class="day-list-item-v2" @click="sortbydays(5)">YTD</li>
            <li class="day-list-item-v2" @click="sortbydays(0)">All</li>
          </ul>
        </div>

        <!-- Payment + Refresh (right) -->
        <div class="input-wrap title_radio">
          <label
            class="pay_types"
            :style="{ color: payment_type == 'paid' ? '#005eb8' : '#b3b3b3' }"
            @click="paymentChange('paid')"
          >Paid</label>
          <label
            class="pay_types"
            :style="{ color: payment_type == 'free' ? '#005eb8' : '#b3b3b3' }"
            @click="paymentChange('free')"
          >Promo</label>
          <label
            class="pay_types"
            :style="{ color: payment_type === 'both' ? '#005eb8' : '#b3b3b3' }"
            @click="paymentChange('both')"
          >All</label>
        </div>
        <span class="download-link" @click="refreshData">
          <span class="refresh-link">
            <img
              v-if="!loading"
              src="../../images/dashboard/refresh.png"
              alt="Refresh"
              class="refresh-link-img"
            />
            <img
              v-else
              class="loading-gif"
              src="../../images/dashboard/loading-gif.svg"
              alt="Refresh"
            />
          </span>
        </span>
      </div>
    </div>

    <!-- Flipkart-style Order Tracking Timeline -->
    <div class="fk-tracker">
      <!-- Row 1: Counts -->
      <div class="fk-row">
        <div
          class="fk-cell"
          v-for="step in pipelineSteps"
          :key="'c-' + step.key"
          @click="filterByStatus(step.statusCode, step.key)"
        >
          <span class="fk-count" :style="{ color: step.color }">{{ report[step.key] }}</span>
        </div>
      </div>
      <!-- Row 2: Dots + Line (line lives here so it always crosses dot centers) -->
      <div class="fk-row fk-dot-row">
        <div class="fk-line" :style="lineInset">
          <div class="fk-line-fill"></div>
        </div>
        <div
          class="fk-cell"
          v-for="step in pipelineSteps"
          :key="'d-' + step.key"
          @click="filterByStatus(step.statusCode, step.key)"
        >
          <div class="fk-dot" :style="{ background: step.color, boxShadow: '0 0 0 3px ' + step.color + '33' }">
            <svg v-if="report[step.key] > 0" class="fk-check" viewBox="0 0 12 12" fill="none">
              <path d="M2.5 6L5 8.5L9.5 3.5" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
      <!-- Row 3: Labels -->
      <div class="fk-row">
        <div
          class="fk-cell"
          v-for="step in pipelineSteps"
          :key="'l-' + step.key"
          @click="filterByStatus(step.statusCode, step.key)"
        >
          <span class="fk-label">{{ step.label }}</span>
        </div>
      </div>
    </div>

    <!-- Overdue Duration Timeline -->
    <div class="main-div-duration-v2">
      <DurationTimelineV2 @showoutlinerkits="showoutlinerkits"></DurationTimelineV2>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DurationTimelineV2 from "./DurationTimelineV2";

export default {
  name: "StateV2",
  components: {
    DurationTimelineV2
  },
  data() {
    return {
      report: {
        shipped: 0,
        activated: 0,
        lab_awaiting: 0,
        lab_received: 0,
        accepted: 0,
        dna_extraction: 0,
        sequencing: 0,
        analysis_completed: 0,
        total: 0
      },
      loading: false,
      payment_type: "paid",
      showDaysList: false,
      dayStep: 30,
      titleMap: {
        30: "30 Days",
        60: "60 Days",
        90: "90 Days",
        1: "Q1",
        2: "Q2",
        3: "Q3",
        4: "Q4",
        5: "YTD",
        0: "All"
      }
    };
  },
  computed: {
    ...mapGetters(["getTimelineStatusV2", "adminReportV2"]),
    pipelineSteps() {
      // Kit V2 dashboard funnel, aligned to the MTC lab workflow. The lab now
      // drives DNA Extraction (13) and Sequencing (14) DURING processing, before
      // Lab Received (3) — the terminal lab stage set on FASTQ upload — so those
      // two stages sit ahead of Lab Received in the funnel. The "Accepted" stage
      // (16) is a lab-portal-only bucket (kits stay Submitted) and is not shown.
      // Report Ready (15) is folded into "Completed" (analysis_completed, 5).
      return [
        { key: "shipped", label: "Sold", statusCode: 0, color: "#005EB8" },
        { key: "activated", label: "Activated", statusCode: 1, color: "#F1B434" },
        { key: "lab_awaiting", label: "Submitted", statusCode: 2, color: "#AC75BD" },
        { key: "dna_extraction", label: "DNA Extraction In Progress", statusCode: 13, color: "#17A2B8" },
        { key: "sequencing", label: "Sequencing In Progress", statusCode: 14, color: "#6F42C1" },
        { key: "lab_received", label: "Lab Received", statusCode: 3, color: "#00BBDC" },
        { key: "analysis_completed", label: "Completed", statusCode: 5, color: "#43B02A" }
      ];
    },
    // Inset the connector line so it runs from the first dot center to the last
    // dot center, regardless of how many steps there are.
    lineInset() {
      const n = this.pipelineSteps.length;
      const half = 100 / (2 * n);
      return { left: half + "%", right: half + "%" };
    }
  },
  watch: {
    getTimelineStatusV2(obj) {
      for (var k in obj) {
        if (this.report.hasOwnProperty(k)) {
          this.report[k] = Number(obj[k]);
        }
      }
    },
    adminReportV2(obj) {
      if (obj && obj.total !== undefined) {
        this.report.total = Number(obj.total);
      }
    }
  },
  methods: {
    ...mapActions([
      "getAdminInfoV2",
      "refreshKitsV2",
      "setPaymentFilterV2",
      "sendSearchReqV2",
      "setStatusFilterV2",
      "overDuesV2",
      "setDaysFilterV2",
      "resetStateV2"
    ]),
    async refreshData() {
      this.loading = true;
      try {
        await this.refreshKitsV2();
      } catch (error) {
        console.error("Error refreshing V2 data", error);
      } finally {
        this.loading = false;
      }
    },
    async paymentChange(val) {
      if (val) {
        this.$emit("clearOutlier");
        await this.setPaymentFilterV2(val);
        this.payment_type = val;
        this.getAdminInfoV2();
      }
    },
    async sortbydays(val) {
      // Clear narrowing filters but preserve payment type
      this.$emit("clearOutlier");
      const currentPayment = this.payment_type;
      this.resetStateV2();
      await this.setPaymentFilterV2(currentPayment);
      await this.setDaysFilterV2(val);
      this.dayStep = val;
      this.showDaysList = false;
      this.getAdminInfoV2();
    },
    closeDaysList() {
      this.showDaysList = false;
    },
    filterByStatus(code, value) {
      this.$emit("switchOrder", { steps: code, value: value });
    },
    showoutlinerkits(val) {
      this.$emit("showoutlinerkits", val);
    }
  },
  mounted() {
    this.payment_type = "paid";
    for (var k in this.$store.getters.getTimelineStatusV2) {
      if (this.report.hasOwnProperty(k)) {
        this.report[k] = Number(this.$store.getters.getTimelineStatusV2[k]);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.state-wrap-v2 {
  background-color: #fff;
  padding: 10px 20px;
  margin-top: 10px;
  margin-bottom: 8px;
  border-radius: 10px;
}

.row {
  display: flex;
  align-items: center;
  margin: 0 0 6px 0;
}

.main_timeline {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* ── Days Filter (left side) ── */
.day-filter-v2 {
  position: relative;
  flex-shrink: 0;
}

.title-filter-v2 {
  color: #005eb8;
  font-size: 14px;
  font-weight: 500;
  font-family: TTNormsMedium, sans-serif;
  cursor: pointer;
  border: 1px solid #e7ecef;
  border-radius: 5px;
  padding: 5px 10px;
  min-width: 90px;
  display: flex;
  align-items: center;
}

.drop-down-menu-v2 {
  margin-left: 5px;
  font-weight: 500;
}

.title-down-v2 {
  height: 14px;
  cursor: pointer;
  vertical-align: middle;
}

.day-list-v2 {
  position: absolute;
  background-color: #fff;
  width: 100%;
  left: 0;
  top: 100%;
  z-index: 10;
  border: 1px solid #e7ecef;
  border-radius: 0 0 5px 5px;
  border-top: 0;
  list-style: none;
  padding: 0;
  margin: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.day-list-item-v2 {
  font-size: 13px;
  font-family: TTNormsLight, sans-serif;
  padding: 8px 14px;
  cursor: pointer;
  color: #000;
  text-align: left;
}

.day-list-item-v2:hover {
  background-color: #f0f0f0;
}

/* ── Payment + Refresh (right side) ── */
.title_radio {
  color: #005eb8;
  font-size: 15px;
  font-weight: 500;
  font-family: TTNormsMedium, sans-serif;
  cursor: pointer;
  margin: 0;
}

.pay_types {
  padding-right: 10px;
  cursor: pointer;
}

.download-link {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.refresh-link {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}

.refresh-link-img {
  height: 24px;
}

.loading-gif {
  width: 26px;
  height: 23.3833px;
}

/* ── Flipkart-style Tracker ── */
.fk-tracker {
  padding: 10px 0 4px;
}

/* Shared row – all three rows use the same grid so columns align */
.fk-row {
  display: flex;
  justify-content: space-between;
}

/* Each cell takes equal width */
.fk-cell {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

/* ── Row 1: Counts ── */
.fk-count {
  font-size: 18px;
  font-family: TTNormsBold, sans-serif;
  font-weight: 500;
  line-height: 1;
  padding-bottom: 4px;
  transition: transform 0.15s ease;
}

.fk-cell:hover .fk-count {
  transform: scale(1.1);
}

/* ── Row 2: Dot row with line ── */
.fk-dot-row {
  position: relative;
  height: 28px;
}

/* Line runs through the vertical center of the dot row,
   from the center of the first dot to the center of the last dot.
   With 5 equal-flex cells the first center is at 1/10 and last at 9/10. */
.fk-line {
  position: absolute;
  top: 50%;
  /* left/right inset is set inline (lineInset) so the line meets the first and
     last dot centers for any number of steps. */
  height: 4px;
  transform: translateY(-50%);
  background: #e8e8e8;
  border-radius: 2px;
  z-index: 0;
}

.fk-line-fill {
  width: 100%;
  height: 100%;
  border-radius: 2px;
  background: linear-gradient(
    90deg,
    #005EB8 0%,
    #F1B434 25%,
    #AC75BD 50%,
    #00BBDC 75%,
    #005EB8 100%
  );
}

/* Dot sits on top of the line */
.fk-dot {
  position: relative;
  z-index: 1;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 3px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.fk-cell:hover .fk-dot {
  transform: scale(1.25);
}

/* Checkmark SVG inside dot */
.fk-check {
  width: 12px;
  height: 12px;
}

/* ── Row 3: Labels ── */
.fk-label {
  padding-top: 4px;
  font-size: 11px;
  font-family: TTNormsMedium, sans-serif;
  color: #000;
  font-weight: 500;
  letter-spacing: 0.2px;
  white-space: normal;
  text-align: center;
  line-height: 1.25;
}

.fk-cell:hover .fk-label {
  color: #333;
}

/* Duration timeline — sits below the tracker with pills between dots */
.main-div-duration-v2 {
  margin-top: 2px;
}

/* ── Responsive ── */
@media (max-width: 1175px) {
  .fk-count {
    font-size: 18px;
  }

  .fk-dot {
    width: 18px;
    height: 18px;
  }

  .fk-check {
    width: 10px;
    height: 10px;
  }

  .fk-label {
    font-size: 10px;
  }

  .fk-line {
    height: 3px;
  }
}

@media (max-width: 768px) {
  /* 9 stages won't fit a phone width — let the whole tracker scroll as a unit
     (all three rows share one scroll container so they stay aligned). */
  .fk-tracker {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .fk-row {
    min-width: 720px;
  }

  .fk-count {
    font-size: 15px;
    padding-bottom: 6px;
  }

  .fk-dot {
    width: 14px;
    height: 14px;
    border-width: 2px;
  }

  .fk-check {
    width: 8px;
    height: 8px;
  }

  .fk-label {
    font-size: 10px;
    padding-top: 6px;
  }

  .fk-line {
    height: 3px;
  }

  .fk-dot-row {
    height: 22px;
  }
}
</style>
